export default __webpack_public_path__ + "static/media/text_logo_black.1239aa88.webp";